// extracted by mini-css-extract-plugin
export default {"expiredSubscriptionModal":"GMV477JOuXwnsKhO83yq","expiredSubscriptionModalSvg":"G9sQwZBofvsPHXcFGeU5","expiredSubscriptionModalDescription":"ejANgtObZMO_J8t6sbWi"};